/*
 * Elcokids - Load More robust (Divas Web Design, oct 2026)
 * ---------------------------------------------------------------------------
 * Inlocuieste cele doua scripturi vechi din theme.liquid
 * ("loadmore-state" din <head> si "Fix scroll Back" de la final).
 *
 * Ce rezolva:
 *  1. Dupa Back din pagina de produs (sau cand browserul de pe mobil
 *     reincarca tab-ul dupa o perioada / din lipsa de memorie), pagina
 *     revenea la primele 20 de produse. Acum starea (cate pagini au fost
 *     incarcate + produsul la care era utilizatorul) se salveaza in
 *     history.state (legat de intrarea din istoric) + sessionStorage ca
 *     rezerva, iar la revenire paginile se reincarca in paralel si pagina
 *     se pozitioneaza pe produsul la care era utilizatorul.
 *  2. Dublu-tap / click repetat pe "Load more" lansa 2 cereri pentru aceeasi
 *     pagina (componenta nu verifica "disabled") -> produse duplicate si
 *     numaratoare gresita. Acum exista un singur request activ per sectiune.
 *  3. Butoanele desktop si mobil (ambele randate in DOM) se desincronizau:
 *     doar cel apasat isi actualiza URL-ul. Acum ambele sunt sincronizate.
 *  4. Se foloseste Section Rendering API (?section_id=) -> raspuns mult mai
 *     mic decat pagina intreaga, deci incarcare mai rapida si mai putina
 *     memorie consumata pe mobil.
 */
(function () {
  'use strict';

  if (window.__elcoLoadMoreInit) return;
  window.__elcoLoadMoreInit = true;

  var STATE_KEY = 'elcoLM';
  var SS_PREFIX = 'elcoLM:';
  var MAX_RESTORE_PAGES = 40;          // limita de siguranta (~800 produse)
  var MAX_AGE_MS = 2 * 60 * 60 * 1000; // starea din sessionStorage expira dupa 2h
  var FETCH_CONCURRENCY = 4;
  var TRACKING_PARAMS = /^(utm_|_ga|_gl|fbclid|gclid|gbraid|wbraid|srsltid|_pos|_sid|_ss|_psq|_fid|mc_|_kx)/i;

  /* ----------------------------------------------------------------- utils */

  function pageKey() {
    var params = new URLSearchParams(location.search);
    var clean = [];
    params.forEach(function (value, key) {
      if (TRACKING_PARAMS.test(key)) return;
      clean.push([key, value]);
    });
    clean.sort(function (a, b) { return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0; });
    var qs = clean.map(function (p) {
      return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]);
    }).join('&');
    return location.pathname + (qs ? '?' + qs : '');
  }

  function navigationType() {
    try {
      var nav = performance.getEntriesByType('navigation');
      if (nav && nav.length && nav[0].type) return nav[0].type;
    } catch (e) {}
    try {
      if (performance.navigation) {
        if (performance.navigation.type === 2) return 'back_forward';
        if (performance.navigation.type === 1) return 'reload';
      }
    } catch (e) {}
    return 'navigate';
  }

  function toAbsUrl(url) {
    return new URL(url, location.origin);
  }

  function pageFromUrl(url) {
    try {
      var p = parseInt(toAbsUrl(url).searchParams.get('page') || '1', 10);
      return isNaN(p) || p < 1 ? 1 : p;
    } catch (e) {
      return 1;
    }
  }

  function withPage(url, page) {
    var u = toAbsUrl(url);
    u.searchParams.set('page', String(page));
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  function cleanPaginationUrl(url) {
    if (!url) return url;
    try {
      var u = toAbsUrl(url);
      u.searchParams.delete('section_id');
      if (!u.searchParams.has('_ajax')) u.searchParams.set('_ajax', '1');
      return u.pathname + u.search;
    } catch (e) {
      return url;
    }
  }

  /* ----------------------------------------------------------------- state */

  var memoryState = null;
  var lastReplace = 0;
  var replaceTimer = null;

  function readState() {
    var key = pageKey();
    try {
      var hs = history.state && history.state[STATE_KEY];
      if (hs && hs.key === key && hs.page > 1) return hs;
    } catch (e) {}

    // Rezerva: doar la Back/Forward sau reload, niciodata la o navigare noua
    // (ex. click din meniu pe categorie -> trebuie sa porneasca de sus).
    var type = navigationType();
    if (type !== 'back_forward' && type !== 'reload') return null;
    try {
      var raw = sessionStorage.getItem(SS_PREFIX + key);
      if (!raw) return null;
      var ss = JSON.parse(raw);
      if (ss && ss.key === key && ss.page > 1 && Date.now() - (ss.t || 0) < MAX_AGE_MS) return ss;
    } catch (e) {}
    return null;
  }

  function commitHistoryState() {
    replaceTimer = null;
    lastReplace = Date.now();
    if (!memoryState) return;
    try {
      var merged = Object.assign({}, history.state || {});
      merged[STATE_KEY] = memoryState;
      history.replaceState(merged, '');
    } catch (e) {
      // Safari limiteaza replaceState (100 apeluri / 30s) - ignoram.
    }
  }

  function saveState(patch, immediate) {
    memoryState = Object.assign({ key: pageKey(), page: 1 }, memoryState || {}, patch || {});
    memoryState.key = pageKey();
    memoryState.t = Date.now();

    try {
      sessionStorage.setItem(SS_PREFIX + memoryState.key, JSON.stringify(memoryState));
    } catch (e) {}

    if (immediate) {
      if (replaceTimer) clearTimeout(replaceTimer);
      commitHistoryState();
      return;
    }
    if (replaceTimer) return;
    var wait = Math.max(0, 1000 - (Date.now() - lastReplace));
    replaceTimer = setTimeout(commitHistoryState, wait);
  }

  function setManualScrollRestoration() {
    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (e) {}
  }

  /* --------------------------------------------------------------- context */

  function getContext(fromEl) {
    var comp = fromEl && fromEl.closest ? fromEl.closest('pagination-component') : null;
    if (!comp) return null;
    var containerId = comp.dataset.containerId;
    var target = comp.dataset.target;
    var container = containerId ? document.getElementById(containerId) : null;
    if (!container || !target) return null;

    var section = comp.closest('.shopify-section');
    var sectionId = null;
    if (section && section.id && section.id.indexOf('shopify-section-') === 0) {
      sectionId = section.id.slice('shopify-section-'.length);
    }
    var scope = section || document;
    var comps = Array.prototype.filter.call(
      scope.querySelectorAll('pagination-component'),
      function (c) { return c.dataset.containerId === containerId; }
    );

    return {
      section: section,
      lockEl: section || container,
      sectionId: sectionId,
      containerId: containerId,
      container: container,
      target: target,
      comps: comps
    };
  }

  function getItems(ctx) {
    return Array.prototype.filter.call(
      ctx.container.querySelectorAll('.' + ctx.target),
      function (el) { return el.parentNode === ctx.container; }
    );
  }

  function productKeyOf(item) {
    var a = item.querySelector('a[href*="/products/"]');
    if (!a) return null;
    try { return toAbsUrl(a.getAttribute('href')).pathname; } catch (e) { return null; }
  }

  function setLoading(ctx, isLoading) {
    ctx.comps.forEach(function (c) {
      var btn = c.querySelector('pagination-load-button');
      if (!btn) return;
      btn.toggleAttribute('disabled', isLoading);
      btn.classList.toggle('loading', isLoading);
    });
  }

  /* ----------------------------------------------------------------- fetch */

  function parseDoc(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function fetchDoc(ctx, url) {
    var full = toAbsUrl(url);
    full.searchParams.delete('section_id');

    var sectionUrl = null;
    if (ctx.sectionId) {
      var su = toAbsUrl(full.href);
      su.searchParams.set('section_id', ctx.sectionId);
      sectionUrl = su.pathname + su.search;
    }

    function get(u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(parseDoc);
    }

    var first = sectionUrl ? get(sectionUrl) : get(full.pathname + full.search);
    return first.then(function (doc) {
      if (doc.getElementById(ctx.containerId)) return doc;
      if (!sectionUrl) throw new Error('container missing');
      return get(full.pathname + full.search);
    }, function (err) {
      if (!sectionUrl) throw err;
      return get(full.pathname + full.search);
    });
  }

  function fetchAll(ctx, urls) {
    var results = new Array(urls.length);
    var index = 0;
    function worker() {
      if (index >= urls.length) return Promise.resolve();
      var i = index++;
      return fetchDoc(ctx, urls[i]).then(function (doc) {
        results[i] = doc;
      }, function () {
        results[i] = null;
      }).then(worker);
    }
    var workers = [];
    for (var w = 0; w < Math.min(FETCH_CONCURRENCY, urls.length); w++) workers.push(worker());
    return Promise.all(workers).then(function () { return results; });
  }

  /* ---------------------------------------------------------------- update */

  function appendItems(ctx, doc, focusFirst) {
    var newContainer = doc.getElementById(ctx.containerId);
    if (!newContainer) return 0;

    var existing = {};
    getItems(ctx).forEach(function (item) {
      var k = productKeyOf(item);
      if (k) existing[k] = true;
    });

    var newItems = Array.prototype.filter.call(
      newContainer.querySelectorAll('.' + ctx.target),
      function (el) { return el.parentNode === newContainer; }
    );

    var fragment = document.createDocumentFragment();
    var firstAdded = null;
    newItems.forEach(function (item) {
      var k = productKeyOf(item);
      if (k && existing[k]) return; // fara duplicate
      if (k) existing[k] = true;
      fragment.appendChild(document.adoptNode(item));
      if (!firstAdded) firstAdded = item;
    });
    ctx.container.appendChild(fragment);

    if (focusFirst && firstAdded) {
      var focusable = firstAdded.querySelector('a[href], button, [tabindex]');
      if (focusable) {
        try { focusable.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    return newItems.length;
  }

  function syncPaginations(ctx, doc) {
    var scope = (ctx.section && doc.getElementById(ctx.section.id)) || doc;
    var newComps = Array.prototype.filter.call(
      scope.querySelectorAll('pagination-component'),
      function (c) { return c.dataset.containerId === ctx.containerId; }
    );

    ctx.comps.forEach(function (comp, i) {
      var fresh = newComps[i] || newComps[0];
      if (!fresh) {
        var oldBtn = comp.querySelector('pagination-load-button');
        if (oldBtn) oldBtn.remove();
        return;
      }
      Array.prototype.forEach.call(fresh.querySelectorAll('pagination-load-button[data-url]'), function (b) {
        b.setAttribute('data-url', cleanPaginationUrl(b.getAttribute('data-url')));
      });
      ['data-current', 'data-total', 'data-page-size'].forEach(function (attr) {
        if (fresh.hasAttribute(attr)) comp.setAttribute(attr, fresh.getAttribute(attr));
      });
      // Copie statica a listei INAINTE de adoptNode (childNodes e o lista "vie"
      // care se micsoreaza pe masura ce mutam nodurile).
      var nodes = Array.prototype.slice.call(fresh.childNodes).map(function (n) {
        return document.adoptNode(n);
      }).filter(function (n) { return n && n.nodeType; });
      comp.replaceChildren.apply(comp, nodes);
    });
  }

  function currentNextUrl(ctx) {
    for (var i = 0; i < ctx.comps.length; i++) {
      var b = ctx.comps[i].querySelector('pagination-load-button[data-url]');
      if (b && b.dataset.url) return b.dataset.url;
    }
    return null;
  }

  /* ------------------------------------------------------------ load more */

  function loadNext(btn) {
    var ctx = getContext(btn);
    if (!ctx) return Promise.resolve(false);

    // Un singur request activ per sectiune (dublu-tap, desktop+mobil etc.)
    if (ctx.lockEl.__elcoBusy) return ctx.lockEl.__elcoBusy;

    var url = btn.dataset.url || currentNextUrl(ctx);
    if (!url) return Promise.resolve(false);

    setLoading(ctx, true);
    var p = fetchDoc(ctx, url).then(function (doc) {
      // Daca intre timp s-a schimbat continutul (ex. filtru aplicat), ignoram.
      var still = currentNextUrl(ctx);
      if (still && cleanPaginationUrl(still) !== cleanPaginationUrl(url)) return false;

      appendItems(ctx, doc, true);
      syncPaginations(ctx, doc);
      setManualScrollRestoration();
      saveState({ page: pageFromUrl(url) }, true);
      return true;
    }).catch(function (err) {
      console.warn('[elco-load-more] eroare la incarcare', err);
      return false;
    }).then(function (res) {
      ctx.lockEl.__elcoBusy = null;
      var fresh = getContext(ctx.comps[0]) || ctx;
      setLoading(fresh, false);
      return res;
    });

    ctx.lockEl.__elcoBusy = p;
    return p;
  }

  function patchLoadButton() {
    if (!window.customElements) return;
    customElements.whenDefined('pagination-load-button').then(function () {
      var Cls = customElements.get('pagination-load-button');
      if (!Cls || !Cls.prototype || Cls.prototype.__elcoPatched) return;
      Cls.prototype.fetchResults = function () {
        return loadNext(this);
      };
      Cls.prototype.__elcoPatched = true;
    });
  }

  /* --------------------------------------------------------------- anchor */

  var userInteracted = false;

  function computeAnchor(ctx) {
    var items = getItems(ctx);
    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.bottom > 0 && r.height > 0) {
        return { anchorIndex: i, anchorKey: productKeyOf(items[i]), anchorOffset: Math.round(r.top) };
      }
    }
    return null;
  }

  function scrollToAnchor(ctx, st) {
    if (!st || st.anchorIndex == null) return;
    var items = getItems(ctx);
    var el = null;
    if (st.anchorKey) {
      for (var i = 0; i < items.length; i++) {
        if (productKeyOf(items[i]) === st.anchorKey) { el = items[i]; break; }
      }
    }
    if (!el) el = items[Math.min(st.anchorIndex, items.length - 1)];
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (st.anchorOffset || 0);
    window.scrollTo(0, Math.max(0, top));
  }

  function trackAnchor(ctx) {
    var t = null;
    function update(immediate) {
      if (!memoryState || memoryState.page <= 1) return;
      var a = computeAnchor(ctx);
      if (a) saveState(a, immediate);
    }
    window.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { update(false); }, 200);
    }, { passive: true });

    // La click pe un produs: salvare imediata a pozitiei exacte.
    document.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('.' + ctx.target) : null;
      if (!item || item.parentNode !== ctx.container) return;
      if (!memoryState || memoryState.page <= 1) return;
      var items = getItems(ctx);
      var idx = items.indexOf(item);
      if (idx < 0) return;
      saveState({
        anchorIndex: idx,
        anchorKey: productKeyOf(item),
        anchorOffset: Math.round(item.getBoundingClientRect().top)
      }, true);
    }, true);

    window.addEventListener('pagehide', function () { update(true); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') update(true);
    });
  }

  /* -------------------------------------------------------------- restore */

  function restore(ctx, st) {
    var nextUrl = currentNextUrl(ctx);
    if (!nextUrl) {
      scrollToAnchor(ctx, st);
      return Promise.resolve();
    }
    var startPage = pageFromUrl(nextUrl);
    var endPage = Math.min(st.page, startPage + MAX_RESTORE_PAGES - 1);
    if (endPage < startPage) {
      scrollToAnchor(ctx, st);
      return Promise.resolve();
    }

    var urls = [];
    for (var p = startPage; p <= endPage; p++) urls.push(withPage(nextUrl, p));

    setLoading(ctx, true);
    var job = fetchAll(ctx, urls).then(function (docs) {
      var lastDoc = null;
      var lastPage = startPage - 1;
      for (var i = 0; i < docs.length; i++) {
        if (!docs[i]) break; // pastram ordinea: ne oprim la prima pagina esuata
        appendItems(ctx, docs[i], false);
        lastDoc = docs[i];
        lastPage = startPage + i;
      }
      if (lastDoc) {
        syncPaginations(ctx, lastDoc);
        ctx = getContext(ctx.comps[0]) || ctx;
      }
      memoryState = Object.assign({}, st, { page: Math.max(lastPage, 1) });
      saveState({}, true);

      var apply = function () { if (!userInteracted) scrollToAnchor(ctx, st); };
      apply();
      requestAnimationFrame(apply);
      setTimeout(apply, 350);
      setTimeout(apply, 1000);
      if (document.readyState !== 'complete') window.addEventListener('load', apply, { once: true });
    }).catch(function (err) {
      console.warn('[elco-load-more] restore esuat', err);
    }).then(function () {
      ctx.lockEl.__elcoBusy = null;
      setLoading(getContext(ctx.comps[0]) || ctx, false);
    });

    ctx.lockEl.__elcoBusy = job;
    return job;
  }

  /* ----------------------------------------------------------------- init */

  function init() {
    patchLoadButton();

    var anyBtn = document.querySelector('pagination-load-button');
    var ctx = anyBtn ? getContext(anyBtn) : null;
    if (!ctx) {
      // Nu exista (inca) buton - poate e ultima pagina; tot incercam pozitia.
      var compOnly = document.querySelector('pagination-component[data-container-id]');
      ctx = compOnly ? getContext(compOnly) : null;
      if (!ctx) return;
    }

    ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (evt) {
      window.addEventListener(evt, function () { userInteracted = true; }, { passive: true, once: true });
    });

    trackAnchor(ctx);

    var st = readState();
    if (st) {
      setManualScrollRestoration();
      memoryState = st;
      restore(ctx, st);
    }
  }

  // Pagina restaurata din bfcache: DOM-ul si scroll-ul sunt deja intacte.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) userInteracted = false;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
